import React, { Fragment } from 'react'
import ReactDOM from 'react-dom'
// import Slider from '@material-ui/lab/Slider'
import Slider from '@material-ui/core/Slider';
import Cropper from 'react-easy-crop'
import { getOrientation } from 'get-orientation/browser'
import getCroppedImg from './cropImage'
// import { getRotatedImage } from './rotateImage'
import './styles.css'
// import { Button } from '@material-ui/core'
import { Button } from "reactstrap";
import { makeStyles } from '@material-ui/core/styles';
import ImgDialog from './ImgDialog'
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Col, Row} from "reactstrap";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";

const ORIENTATION_TO_ANGLE = {
  '3': 180,
  '6': 90,
  '8': -90,
}

class App extends React.Component {
  state = {
    base64Code: null,
    imageSrc: null,
    crop: { x: 0, y: 0 },
    zoom: 1,
    aspect: 4 / 4,
    croppedAreaPixels: null,
    croppedImage: null,
    isCropping: false,
  }

  onCropChange = crop => {
    //   console.log("CROP", crop);
    this.setState({ crop })
  }

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    // console.log(croppedArea, croppedAreaPixels)
    this.setState({
      croppedAreaPixels,
    })
  }

  onZoomChange = zoom => {
    this.setState({ zoom })
  }



  showResult = async () => {
    let croppedImage = "";
    try {
      this.setState({
        isCropping: true,
      });

      this.props.spinnerHandler(true);
       croppedImage = await getCroppedImg(
        this.state.imageSrc,
        this.state.croppedAreaPixels
      );
      this.props.spinnerHandler(false);

      // console.log('done', { croppedImage });
      this.setState({
        croppedImage,
        isCropping: false,
      })
    } catch (e) {
    //   console.error(e)
      this.setState({
        isCropping: false,
      })
    }

    let blob = await fetch(this.state.croppedImage).then(r => r.blob());

    let file = new File([blob], "name", {type: blob.type});

    this.props.parentMethod(blob, croppedImage, file);

    // let reader = new FileReader();
    // reader.readAsDataURL(blob);

    // reader.onload = function() {
    //     let x = reader.result; // data url
    //   };

let b ="";

    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      var base64String = reader.result;
      // console.log('Base64 String - ', base64String);

      // Simply Print the Base64 Encoded String,
      // without additional data: Attributes.
      // console.log('Base64 String without Tags- ',
      //   base64String.substr(base64String.indexOf(', ') + 1));

      b = base64String;

    }

    // this.onClose();
    this.props.closeModal();

    this.toggle();

  }

  onClose = async () => {
    this.setState({
      croppedImage: null,
    })
  }

  toggle = () =>{}

  // onFileChange = async e => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     const file = e.target.files[0]
  //     let imageDataUrl = await readFile(file)
  //
  //     // apply rotation if needed
  //   //   const orientation = await getOrientation(file)
  //   //   const rotation = ORIENTATION_TO_ANGLE[orientation]
  //   //   if (rotation) {
  //   //     imageDataUrl = await getRotatedImage(imageDataUrl, rotation)
  //   //   }
  //
  //     this.setState({
  //       imageSrc: imageDataUrl,
  //       crop: { x: 0, y: 0 },
  //       zoom: 1,
  //     })
  //   }
  // }


  makeCancel = () => {

    this.props.closeModal();

  };

  componentDidMount() {

    this.setState({
      imageSrc: this.props.imageDataUrl,
      // imageSrc: "https://p.bigstockphoto.com/eIdTXLbqQilMs9xbjvcs_bigstock-Aerial-View-Of-Sandy-Beach-Wit-256330393.jpg",
      crop: { x: 0, y: 0 },
      zoom: 1,
    })

  }




  render() {


    // const StyledButton = makeStyles({
    //   root: {
    //     background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    //     borderRadius: 3,
    //     border: 0,
    //     color: 'white',
    //     height: 48,
    //     padding: '0 30px',
    //     boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    //   },
    //   label: {
    //     textTransform: 'capitalize',
    //   },
    // })(Button);


    return (

      <div style={{padding:'10px', background:'#eeeeee'}} className={"easycrop-wrapper"}>


        {/*<MDBModal isOpen={true} toggle={this.toggle} size="xl">*/}
          {/*<MDBModalHeader className={"title"} toggle={this.props.closeModalX}>Crop Image</MDBModalHeader>*/}
          {/*<MDBModalBody>*/}
            <Row style={{padding: '10px'}}>
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                <Row>
                  <Col lg={12}>




                      {/*<input type="file" onChange={this.onFileChange} />*/}
                      {this.state.imageSrc && (
                        <Fragment>
                          <div className="crop-container">
                            <Cropper
                              image={this.state.imageSrc}
                              crop={this.state.crop}
                              zoom={this.state.zoom}
                              aspect={this.state.aspect}
                              onCropChange={this.onCropChange}
                              onCropComplete={this.onCropComplete}
                              onZoomChange={this.onZoomChange}
                            />
                          </div>
                          <div className="controls">
                            <Slider
                              value={this.state.zoom}
                              min={1}
                              max={3}
                              step={0.1}
                              aria-labelledby="Zoom"
                              onChange={(e, zoom) => this.onZoomChange(zoom)}
                              // classes={{ container: 'slider' }}
                            />
                          </div>
                          <div className="">
                            {/*<StyledButton*/}
                              {/*color="primary"*/}
                              {/*variant="contained"*/}
                              {/*onClick={this.showResult}*/}
                              {/*disabled={this.state.isCropping}*/}
                            {/*>*/}
                              {/*Show result*/}
                            {/*</StyledButton>*/}



                          </div>
                          {/* <ImgDialog img={this.state.croppedImage} onClose={this.onClose} /> */}
                          {/* <ImgDialog img={this.state.croppedImage} /> */}

                          <Button
                            className="button"
                            color="primary"
                            onClick={this.showResult}
                            disabled={this.state.isCropping}
                            style={{padding:'10px'}}
                          > Crop and Set </Button>


                          <Button
                            className="button2"
                            color="secondary"
                            onClick={this.makeCancel}
                            disabled={this.state.isCropping}
                            style={{padding:'10px'}}
                          > Cancel </Button>

                          {/*<img src = {this.state.croppedImage} />*/}

                        </Fragment>
                      )}




                  </Col>
                </Row>
              </Col>
            </Row>
          {/*</MDBModalBody>*/}
        {/*</MDBModal>*/}


      </div>

    )
  }

}

// function readFile(file) {
//   return new Promise(resolve => {
//     const reader = new FileReader()
//     reader.addEventListener('load', () => resolve(reader.result), false)
//     reader.readAsDataURL(file)
//   })
// }

// const rootElement = document.getElementById('root')
// ReactDOM.render(<App />, rootElement)

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
